/**
 * Bezohminds brand assets.
 * Logo is the wing mark. The center icon is the full wordmark.
 */
export const BRAND_NAME = "Bezohminds";
export const BRAND_LOGO = "/bezohminds-logo.png";
export const BRAND_CENTER_ICON = "/bezohminds-center.png";
export const BRAND_HEADER_LOGO = "/bezohminds-header.png";
